import { render, staticRenderFns } from "./selfPrice.vue?vue&type=template&id=583d5072&scoped=true"
import script from "./selfPrice.vue?vue&type=script&lang=js"
export * from "./selfPrice.vue?vue&type=script&lang=js"
import style0 from "./selfPrice.vue?vue&type=style&index=0&id=583d5072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583d5072",
  null
  
)

export default component.exports